/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactInputsComponent } from './contact-inputs/contact-inputs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PersonManagementModule } from '@well/person-management';
import { ContactAutocompleteComponent } from './contact-autocomplete/contact-autocomplete.component';
import { PersonAutocompleteModule } from '@well/person-autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { SelectModule, Select } from 'primeng/select';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule, AutoComplete } from 'primeng/autocomplete';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { CompanyPartnerContactAddComponent } from './company-partner-contact-add/company-partner-contact-add.component';
import { CompanyPartnerContactAddDialogComponent } from './company-partner-contact-add-dialog/company-partner-contact-add-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { EmailContactUnsubscribeViewComponent } from './email-contact-unsubscribe-view/email-contact-unsubscribe-view.component';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { InputTrimDirective } from '@well/infra/directives';
import { FloatLabel } from 'primeng/floatlabel';
import {
  BsAutocompleteComponent,
  BsItemDirective
} from 'iriro-frontend-libs/bs-component-store';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    InputTextModule,
    PersonManagementModule,
    AutoCompleteModule,
    TabViewModule,
    PersonAutocompleteModule,
    ButtonModule,
    BlockUIModule,
    SelectModule,
    ToggleSwitch,
    SharedComponentsModule,
    DialogModule,
    TooltipModule,
    FormInlineErrorDirective,
    InputTrimDirective,
    FloatLabel,
    AutoComplete,
    ToggleSwitch,
    Select,
    BsAutocompleteComponent,
    BsItemDirective
  ],
  declarations: [
    ContactInputsComponent,
    ContactAutocompleteComponent,
    CompanyPartnerContactAddComponent,
    CompanyPartnerContactAddDialogComponent,
    EmailContactUnsubscribeViewComponent
  ],
  exports: [
    ContactInputsComponent,
    ContactAutocompleteComponent,
    CompanyPartnerContactAddComponent,
    CompanyPartnerContactAddDialogComponent,
    EmailContactUnsubscribeViewComponent
  ],
})
export class ContactManagementModule {}
